module.exports = __webpack_public_path__ + "static/media/splendor.34540c3b.jpg";